import { useUserSession } from '@/composables/useUserSession';
import { useStoreUser } from '@/stores/storeUser';
import loggerLocal from '@/utils/loggerLocal';
import { createRouter, createWebHistory } from 'vue-router';
import { getCurrentUser } from 'vuefire';
import AuthRoutes from './AuthRoutes';
import MainRoutes from './MainRoutes';
import { authRoutesName, initialPageRoute, routesName } from './routeName';
import { waitForFirebaseUser } from './routerUtils';




//keep the order of routes to avoid problems with the redirect of empty routes
//that should be redirect to dashboard
const routesList = [
    ...MainRoutes,
    ...AuthRoutes,
];



export const router = createRouter( {
    history: createWebHistory( import.meta.env.BASE_URL ),
    routes:
        routesList,

} );






router.beforeEach( async ( to, from, next ) => {
    const functionName = 'Router.beforeEach'
    try
    {
        // redirect to login page if not logged in and trying to access a restricted page
        const token = await waitForFirebaseUser(); // 🔑 Autenticazione reale
        //const isPublicRoute = Object.values( authRoutesName ).includes( to.path );
        const publicRouteNames = new Set( Object.values( authRoutesName ) );
        const isPublicRoute = publicRouteNames.has( to.name as string );
        const requiresAuth = to.matched.some( record => record.meta.requiresAuth );
        //const currentSession = await getCurrentSession()
        //const currentSession = await waitForUserReady()
        //const tokenExists = currentSession != undefined
        const tokenExists = !!token;
        loggerLocal.info( functionName,
            'routes to',
            to?.name,
            'from',
            from?.name,
            'next',
            next?.name,
            'meta',
            to?.meta,
            'tokenExists',
            tokenExists,
            'token', token,
            'requiresAuth',
            requiresAuth,
            'isPublicRoute', isPublicRoute
        )
        //const publicRouteNames = Object.values( authRoutesName );
        //const authRequired = !publicRouteNames.includes( to.name as string );
        //loggerLocal.info( '🚦 routesName.login:', routesName.login, 'authRequired:', authRequired );
        /*if ( !to.name )
        {
            if ( !to.name && from.name === undefined )
            {
                loggerLocal.warn( '⚠️ to avoid infinite loop redirect to login' );
                return next( { path: '/login' } );
            }
            loggerLocal.warn( '⚠️ Nessun to.name definito, redirect forzato a login' );
            const pageToGo = routesName.login
            return next( { name: pageToGo } )
        }*/

        // 🔐 ROUTE PROTETTA
        if ( requiresAuth )
        {
            if ( !tokenExists )
            {
                return next( { name: routesName.login } );
            }

            const user = await getCurrentUser();

            if ( !user?.emailVerified )
            {
                loggerLocal.info( functionName, 'Email not verified' );
                return next( { name: routesName.verifyEmail } );
            }

            //const ok = await initUserData();
            const { init } = useUserSession();
            const ok = await init();
            //const ok = init
            loggerLocal.info( functionName, 'User session initialized:', ok );
            if ( !ok )
            {
                return next( { name: routesName.login } );
            }
            // ⭐️ Nuovo codice per controllare "manager"
            const requiresManager = to.matched.some( record => record.meta.manager );

            if ( requiresManager )
            {
                const storeUser = useStoreUser();

                if ( !storeUser.getIsCompanyManager )
                {
                    // Utente non manager, reindirizza ad esempio a dashboard o pagina non autorizzata
                    loggerLocal.info( functionName, 'User is not a manager, access denied.' );
                    return next( { name: routesName.notAuthorized } );
                } else
                {
                    loggerLocal.info( functionName, 'User is a manager, access granted.' );
                }
            }
            loggerLocal.info( functionName, 'User session initialized, ready to go next() ==>', to?.name );

            return next(); // ✅ Tutto OK
        }
        // 🔓 ROUTE PUBBLICA
        if ( to.name === routesName.login && tokenExists )
        {
            return next( { name: initialPageRoute } ); // utente già loggato, evitiamo login
        }

        loggerLocal.info( functionName, '🚦 Calling next() → allowed route', to?.name );

        return next(); // 🚶‍♂️ Tutto libero
    } catch ( err )
    {
        loggerLocal.error( functionName, '[Router Guard Error]', err );
        return next( { name: routesName.login } ); // fallback sicuro
    }
    finally
    {
        //loggerLocal.warn( '📍 END OF ROUTE GUARD' );
    }
} );




router.onError( ( err, to ) => {
    const msg = String( ( err as any )?.message ?? err );

    // Log sempre
    loggerLocal.error( 'Router load error for', to?.fullPath, err );

    // Riconosci gli errori tipici di lazy chunk
    const isChunkError =
        /ChunkLoadError/i.test( msg ) ||
        /Loading chunk \d+ failed/i.test( msg ) ||
        /Failed to fetch dynamically imported module/i.test( msg ) ||
        /Importing a module script failed/i.test( msg );

    if ( isChunkError )
    {
        // 🔧 prova a "bustare" la cache (utile con SW o CDN aggressiva)
        const reloadWithBust = async () => {
            try
            {
                // Se usi un Service Worker, prova a forzare l’update
                if ( 'serviceWorker' in navigator )
                {
                    const regs = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(
                        regs.map( async ( r ) => {
                            try
                            {
                                await r.update();
                                if ( r.waiting ) r.waiting.postMessage( { type: 'SKIP_WAITING' } );
                            } catch { }
                        } ),
                    );
                }
            } catch { }

            // Hard reload con query param per invalidare cache
            const url = new URL( window.location.href );
            url.searchParams.set( 'v', String( Date.now() ) );
            window.location.replace( url.toString() );
        };

        // Se fallisce il primo load, ricarica subito
        reloadWithBust();
    }
} );

window.addEventListener( 'error', ( e ) => {
    const msg = String( ( e?.error?.message ?? e?.message ) || '' );
    const isChunkError =
        /ChunkLoadError/i.test( msg ) ||
        /Loading chunk \d+ failed/i.test( msg ) ||
        /Importing a module script failed/i.test( msg );

    loggerLocal.error( 'Global error:', e?.error || e?.message, e );

    if ( isChunkError )
    {
        // lascia che router.onError faccia il suo lavoro sul prossimo nav,
        // oppure ricarica qui se necessario
    }
} );

window.addEventListener( 'unhandledrejection', ( e ) => {
    loggerLocal.error( 'Unhandled promise rejection:', e?.reason );
} );

export { initialPageRoute, routesName };

